@import '../../vars.css';

.lockIcon_default {
    color: var(--color-light-neutral-translucent-500);
}

.lockIcon_inverted {
    color: var(--color-light-neutral-translucent-500-inverted);
}
